import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { FieldInterventionsService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class FieldInterventionListBloc extends Bloc<FieldInterventionsService['fieldInterventionControllerGet']> {
    public constructor(service: FieldInterventionsService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.fieldInterventionControllerGet.bind(service), {
            debug: debug ?? false,
        });
    }
}
